import Router from 'vue-router';
import ContactUsForm from '../../../../qaamgo/modules/sat/components/ContactUsForm';

const contactUsModalRoute = {
    CONTACT_US: 'contact-us',
};

export { contactUsModalRoute };

const contactUsModalRouter = new Router({
    mode: 'abstract',
    routes: [
        {
            path: '/contact-us/:defaultQuestionType',
            name: contactUsModalRoute.CONTACT_US,
            component: ContactUsForm,
            props: true,
        },
    ],
});

export { contactUsModalRouter };
